import { extendTailwindMerge } from "tailwind-merge";
import { createTV } from "tailwind-variants";

import { tailwindPreset } from "../../tailwindpreset";

const customTwMergeConfig = {
  extend: {
    classGroups: {
      "font-size": [
        {
          text: Object.keys(tailwindPreset.theme?.fontSize ?? {}),
        },
      ],
      "border-radius": [
        {
          rounded: Object.keys(tailwindPreset.theme?.borderRadius ?? {}),
        },
      ],
    },
  },
  override: {
    theme: {
      spacing: Object.keys(tailwindPreset.theme?.spacing ?? {}),
    },
  },
};

export const customTv = createTV({
  twMerge: true,
  twMergeConfig: customTwMergeConfig,
});

export const customTwMerge = extendTailwindMerge(customTwMergeConfig);
